import { render, staticRenderFns } from "./NewPortModal.vue?vue&type=template&id=622bb954&scoped=true"
import script from "./NewPortModal.vue?vue&type=script&lang=js"
export * from "./NewPortModal.vue?vue&type=script&lang=js"
import style0 from "./NewPortModal.vue?vue&type=style&index=0&id=622bb954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622bb954",
  null
  
)

export default component.exports